import { __awaiter, __generator, __read } from "tslib";
import { getSearchCenterUrl } from '../search-center-url/getSearchCenterUrl';
import { getXAnchorMailbox } from '../settings';
/**
 * Calls the init endpoint of 3S to warmup the subsequent queries
 */
export function warmup3S(_a) {
    var searchPrefetch = _a.searchPrefetch, searchSettings = _a.searchSettings, searchHostAppLogger = _a.searchHostAppLogger;
    return __awaiter(this, void 0, void 0, function () {
        var _b, prefetch, tokenProviders, searchConfig, officeContext, searchMiddleTierEnvironment, userEntitlements, _c, xAnchorMailbox, searchCenterUrl, substrateTokenProvider, fastUseSubstrateEnabled, preferredCulture, sharePointResourceId;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        searchPrefetch.getModule(),
                        searchSettings.getTokenProviders(),
                        searchSettings.getSearchConfig(),
                        searchSettings.getOfficeComponentContext(),
                        searchSettings.getSearchMiddleTierEnvironment(),
                        searchSettings.getUserEntitlements(),
                    ])];
                case 1:
                    _b = __read.apply(void 0, [_d.sent(), 6]), prefetch = _b[0], tokenProviders = _b[1], searchConfig = _b[2], officeContext = _b[3], searchMiddleTierEnvironment = _b[4], userEntitlements = _b[5];
                    return [4 /*yield*/, Promise.all([
                            getXAnchorMailbox(searchSettings),
                            getSearchCenterUrl(searchPrefetch, searchSettings, searchHostAppLogger),
                        ])];
                case 2:
                    _c = __read.apply(void 0, [_d.sent(), 2]), xAnchorMailbox = _c[0], searchCenterUrl = _c[1];
                    substrateTokenProvider = tokenProviders.substrateTokenProvider;
                    fastUseSubstrateEnabled = searchConfig.fastUseSubstrateEnabled;
                    preferredCulture = officeContext.preferredCulture;
                    sharePointResourceId = (userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.SharePointResourceId) || '';
                    return [2 /*return*/, prefetch.warmupSubstrateSearch({
                            tokenProvider: substrateTokenProvider,
                            headers: {
                                'x-client-language': preferredCulture,
                                'x-anchormailbox': xAnchorMailbox || '',
                            },
                            postAction: fastUseSubstrateEnabled ? 'initv2' : 'init',
                            substrateUrl: prefetch.resolveSubstrateUrl(searchMiddleTierEnvironment),
                            queryStringParameters: {
                                scenario: 'officehome',
                                userContextUrl: searchCenterUrl === '/search'
                                    ? "".concat(sharePointResourceId, "/search")
                                    : searchCenterUrl || '',
                            },
                        })];
            }
        });
    });
}
//# sourceMappingURL=warmup3S.js.map